import BatchStatusBadge from './BatchStatusBadge';

interface ProcessCardProps {
    label: string;
    isEnabled: boolean;
    status?: string;
    statusFormatted?: string;
    receivedCount?: number;
    pendingCount?: number;
    validatedCount?: number;
}

const ProcessCard = ({ label, isEnabled, status, statusFormatted, receivedCount = 0, pendingCount = 0, validatedCount = 0 }: ProcessCardProps) => (
    <div className={`rounded p-3 border-2 ${isEnabled ? 'bg-white dark:bg-slate-800 border-blue-200 dark:border-blue-700 shadow-sm' : 'bg-gray-50 dark:bg-slate-900 border-gray-100 dark:border-slate-800 opacity-50'}`}>
        <span className={`text-[10px] font-semibold uppercase ${isEnabled ? 'text-gray-600 dark:text-gray-300' : 'text-gray-400 dark:text-gray-600'}`}>{label}</span>
        <div className="mt-2 space-y-1 text-xs">
            <div className="flex justify-between"><span className="text-gray-500">Obrigatório</span><span>{isEnabled ? 'Sim' : 'Não'}</span></div>
            <div className="flex justify-between items-center"><span className="text-gray-500">Status</span><BatchStatusBadge status={status || ''} statusFormatted={statusFormatted || status || ''} /></div>
            <div className="flex justify-between"><span className="text-gray-500">Recebidos</span><span>{receivedCount}</span></div>
            <div className="flex justify-between"><span className="text-gray-500">Pendentes</span><span>{pendingCount}</span></div>
            <div className="flex justify-between"><span className="text-gray-500">Validados</span><span>{validatedCount}</span></div>
        </div>
    </div>
);

export default ProcessCard;
